const markets = [
  "Major sports markets", "Stadium districts", "Tourist destinations",
  "Malls & lifestyle centers", "Resorts & casinos", "Family entertainment centers",
  "College towns", "International franchise",
];

const scale = [
  "Repeatable venue layout",
  "Standardized LED room architecture",
  "Centralized software platform",
  "Expanding moment library",
  "Consistent operating playbooks",
  "Membership, leaderboard, and league systems",
  "Sponsorship and local partnership templates",
  "Data-driven franchise economics",
];

export function Franchise() {
  return (
    <section id="franchise" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 led-grid opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      <div className="relative mx-auto max-w-6xl px-6">
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Franchise Opportunity</p>
          <h2 className="font-display text-4xl sm:text-6xl leading-tight max-w-4xl mx-auto">
            Built to scale through <span className="text-gradient-ember">franchising.</span>
          </h2>
          <p className="mt-6 max-w-3xl mx-auto text-lg text-muted-foreground leading-relaxed">
            ClutchCube is designed to become a repeatable entertainment model for major sports
            markets, stadium districts, tourist destinations, lifestyle centers, resorts,
            casinos, family entertainment centers, college towns, and international franchise
            partners.
          </p>
          <div className="mt-12 flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
            {markets.map((m) => (
              <span key={m} className="px-4 py-2 text-sm border border-primary/30 bg-primary/5 text-foreground rounded-sm">
                {m}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-20 border border-border/60 bg-card/40 backdrop-blur-[2px] rounded-sm p-10">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-6 text-center">Why the model can scale</p>
          <ul className="grid sm:grid-cols-2 gap-x-10 gap-y-4">
            {scale.map((s) => (
              <li key={s} className="flex items-start gap-3 text-foreground/90 leading-relaxed">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12 text-center space-y-4">
          <p className="text-muted-foreground">
            Interested in franchise development or strategic partnership? Request the investor deck.
          </p>
          <a
            href="#invest"
            className="inline-flex items-center justify-center px-7 py-4 bg-primary text-primary-foreground font-semibold uppercase tracking-widest text-sm rounded-sm shadow-glow hover:translate-y-[-2px] transition"
          >
            Request Investor Deck
          </a>
        </div>
      </div>
    </section>
  );
}
